/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const capacityPerformanceEnumsPotentialConsequenceOptionEnum = {
    SLARisk: 'SLARisk',
    RedundancyLoss: 'RedundancyLoss',
    Outage: 'Outage',
    Other: 'Other',
} as const;

export type CapacityPerformanceEnumsPotentialConsequenceOptionEnumKey =
    (typeof capacityPerformanceEnumsPotentialConsequenceOptionEnum)[keyof typeof capacityPerformanceEnumsPotentialConsequenceOptionEnum];

export type CapacityPerformanceEnumsPotentialConsequenceOption =
    CapacityPerformanceEnumsPotentialConsequenceOptionEnumKey;
